import { render, staticRenderFns } from "./Breadcrumbs.old.vue?vue&type=template&id=7285f679"
import script from "./Breadcrumbs.old.vue?vue&type=script&lang=js"
export * from "./Breadcrumbs.old.vue?vue&type=script&lang=js"
import style0 from "./Breadcrumbs.old.vue?vue&type=style&index=0&id=7285f679&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports